import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiEndpoint } from '@shared/shared/enums/api-endpoints.enum';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as MemberProfilePhoneNumberActions from '../actions/member-profile-phone-number.actions';

@Injectable()
export class MemberProfilePhoneNumberEffects {
  constructor(private actions$: Actions, private http: HttpClient) {}

  public createProfilePhoneNumber$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MemberProfilePhoneNumberActions.CREATE_PROFILE_PHONE_NUMBER),
      switchMap((action: MemberProfilePhoneNumberActions.CreateProfilePhoneNumber) => {
        return this.http.post(ApiEndpoint.MEMBER_PROFILE_PHONE_NUMBER, action.payload).pipe(
          map((phoneNumber) => new MemberProfilePhoneNumberActions.CreateProfilePhoneNumberSuccess(phoneNumber)),
          catchError(() => of(new MemberProfilePhoneNumberActions.CreateProfilePhoneNumberFail()))
        );
      })
    )
  );

  public destroyProfilePhoneNumber$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MemberProfilePhoneNumberActions.DESTROY_PROFILE_PHONE_NUMBER),
      switchMap((action: MemberProfilePhoneNumberActions.DestroyProfilePhoneNumber) => {
        const url = `${ApiEndpoint.MEMBER_PROFILE_PHONE_NUMBER}${action.payload}/`;

        return this.http.delete(url).pipe(
          map(() => new MemberProfilePhoneNumberActions.DestroyProfilePhoneNumberSuccess(action.payload)),
          catchError(() => of(new MemberProfilePhoneNumberActions.DestroyProfilePhoneNumberFail()))
        );
      })
    )
  );

  public updateProfilePhoneNumber$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MemberProfilePhoneNumberActions.UPDATE_PROFILE_PHONE_NUMBER),
      switchMap((action: MemberProfilePhoneNumberActions.UpdateProfilePhoneNumber) => {
        const url = `${ApiEndpoint.MEMBER_PROFILE_PHONE_NUMBER}${action.payload.id}/`;

        return this.http.patch(url, action.payload.data).pipe(
          map((updatedNumber) => new MemberProfilePhoneNumberActions.UpdateProfilePhoneNumberSuccess(updatedNumber)),
          catchError(() => of(new MemberProfilePhoneNumberActions.UpdateProfilePhoneNumberFail()))
        );
      })
    )
  );
}
